import moment from 'moment';
import { CSSProperties, SetStateAction } from 'react';
import DP from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { getBaseUrl } from '../../Utils';

export default function DatePicker(props: {
    id?:string;
    dateFormat: string;
    setStartingDate: (value: string) => void;
    classes?: string | undefined;
    style?: CSSProperties | undefined;
    inputClass?:string | undefined
    showIcon?: boolean;
    startingDate: Date | null | undefined;
    showTime?: boolean;
    interval?: number;
    placeholder?:string;
    value?:string;
    onKeyDown?: (event: React.KeyboardEvent<HTMLElement>) => void; 
    showUnicornDateIcon?: boolean;
    selectedDate?: Date | null | undefined;
    size?: string;
    disabled?: boolean;
}) {
    const icon = props.showIcon ? (
        <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 48 48">
            <mask id="ipSApplication0">
                <g fill="none" stroke="#fff" strokeLinejoin="round" strokeWidth="4">
                    <path strokeLinecap="round" d="M40.04 22v20h-32V22"></path>
                    <path
                        fill="#fff"
                        d="M5.842 13.777C4.312 17.737 7.263 22 11.51 22c3.314 0 6.019-2.686 6.019-6a6 6 0 0 0 6 6h1.018a6 6 0 0 0 6-6c0 3.314 2.706 6 6.02 6c4.248 0 7.201-4.265 5.67-8.228L39.234 6H8.845l-3.003 7.777Z"
                    ></path>
                </g>
            </mask>
            <path fill="currentColor" d="M0 0h48v48H0z" mask="url(#ipSApplication0)"></path>
        </svg>
    ) : null;
    
    const handleDateChange = (date: Date | null) => {
        if (date !== null) {
            // Format the date using moment to prevent time zone issues
            const formattedDate = moment(date).format(props.dateFormat);
            props.setStartingDate(formattedDate);
        } else {
            props.setStartingDate('');
        }
    };

    const handleDateRender = (date: Date | null) => {
        // Ensure the input field is always showing the correct date format without automatic adjustment
        if (date !== null) {
            return moment(date).format(props.dateFormat);
        }
        return '';
    };

    return (
        <span className={props.classes} style={props.style}>
            <DP
                dateFormat={props.dateFormat.replaceAll('D', 'd')}
                selected={props.startingDate ? new Date(props.startingDate) : null} // Use native Date object
                onChange={handleDateChange}
                showTimeSelect={props.showTime || false}
                timeFormat="h:mm a"
                timeIntervals={props.interval || 5}
                placeholderText={props.showTime ? 'Select Date and Time' : 'Select Date'}
                onKeyDown={(event) => {
                    if (event.key === 'Backspace' && !props.value) {
                        props.setStartingDate(''); // Handle backspace key correctly
                    }
                    if (props.onKeyDown) props.onKeyDown(event);
                }}
                value={handleDateRender(props.startingDate ? new Date(props.startingDate) : null)} // Handle custom rendering
                customInput={<input className= {props.inputClass? props.inputClass :""}   readOnly />}
                popperPlacement='bottom'
                disabled={props.disabled}
            />
            {
                props.showUnicornDateIcon && (
                    <img className='ml-1' src={getBaseUrl() + "/images/date.png"} alt="" />
                )
            }
        </span>
    );
}
